export default (params) => ({
  trigger: {
    name: 'content_blocks.header.select_link',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'header',
          'branded_header',
          'header_propositions',
        ],
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'select_navigation',
    },
    nonInt: false,
  },
});
